<template>
  <footer class="c-footer" v-show="global.hasFooter">
    <footer-brands></footer-brands>
    
    <div class="c-footer__body">
      <div class="c-footer__content">
        <div class="c-footer__logo">
          <router-link to="/">
            <svg class="c-logo c-logo--casino c-logo--casino-inverted c-logo--casino-sm"><use xlink:href="#logo-casino-inverted-mark"></use></svg>
          </router-link>
        </div>

        <ul class="c-footer__links c-list">
          <li class="c-list__item"><router-link class="c-list__item-link" to="/casinos" data-test="footer-casinos">{{ $speak('all_casinos') }}</router-link></li>
          <li class="c-list__item"><router-link class="c-list__item-link" to="/games" data-test="footer-games">{{ $speak('all_games') }}</router-link></li>
          <li class="c-list__item"><router-link class="c-list__item-link" to="/offers" data-test="footer-offers">{{ $speak('all_offers') }}</router-link></li>
          <li class="c-list__item"><router-link class="c-list__item-link" to="/city" data-test="footer-city">{{ $speak('the_city') }}</router-link></li>
          <li class="c-list__item"><router-link class="c-list__item-link" to="/news" data-test="footer-news">{{ $speak('news') }}</router-link></li>

          <li class="c-list__item"><router-link class="c-list__item-link" to="/terms-and-conditions" data-test="footer-terms">{{ $speak('terms_and_conditions') }}</router-link></li>
          <li class="c-list__item"><router-link class="c-list__item-link" to="/privacy-policy" data-test="footer-privacy">{{ $speak('privacy_policy') }}</router-link></li>
          <li class="c-list__item"><a class="c-list__item-link" href="mailto:info@casino.eu" data-test="footer-contact">{{ $speak('contact_us') }}</a></li>
          <li class="c-list__item"><a class="c-list__item-link" href="https://gambling.eu" target="_blank" data-test="footer-work">{{ $speak('work_with_us') }}</a></li>
          <li class="c-list__item"><a class="c-list__item-link" href="https://developers.casino.eu" target="_blank" data-test="footer-api">{{ $speak('game_api') }}</a></li>
        </ul>

        <div class="c-footer__extras">
          <div class="c-footer__extras-logos">
            <div class="c-footer__extras-logos-row">
              <!-- <img src="/images/logos/playsafe-logo.svg" alt=""> -->
              <img class="c-footer__edps-image" v-lazy="`/images/logos/EDPS-logo.png`" alt="">
              <a href="https://www.begambleaware.org/" target="_blank"><img v-lazy="`/images/logos/gamble-aware-logo.svg`" alt=""></a>
              <img v-lazy="`/images/logos/device-friendly-logo.svg`" alt="">
            </div>
            <div class="c-footer__extras-logos-row">
              <img class="c-footer__extras-18plus" v-lazy="`/images/logos/18plus-logo.svg`" alt="">
            </div>
          </div>
          <div class="c-footer__extras-allfuture">
            <span class="c-footer__extras-allfuture-text">
              {{ $speak('created_by') }} <a class="t-link t-link--white" href="http://allfuture.com" target="_blank">Allfuture.com</a>
            </span>
            <svg @click="afLogoAnim()" class="c-footer__extras-allfuture-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 79">
              <path id="afLogoFlame" d="M27.43,67.56l2.65-9.66H24.24l2.65,9.66a0.28,0.28,0,0,0,.54,0" fill="#dc4f37"/>
              <g id="afLogoSmoke">
                <path d="M17.67,74.09a5,5,0,0,0-5,4.91h10a5,5,0,0,0-5-4.91" fill="#dc4f37"/>
                <path d="M37.45,74.88a4.25,4.25,0,0,0-1.82.41,8.67,8.67,0,0,0-14.43-2A8.53,8.53,0,0,1,26.69,79h15a4.16,4.16,0,0,0-4.2-4.12" fill="#dc4f37"/>
              </g>
              <path id="afLogoR" d="M47.33,37.94a3.26,3.26,0,1,1-6.52,0,3.26,3.26,0,0,1,6.52,0h0Zm-0.59,0a2.68,2.68,0,1,0-2.69,2.67,2.64,2.64,0,0,0,2.69-2.67h0Zm-2.49-1.71a1.24,1.24,0,0,1,1.47,1.21,1.09,1.09,0,0,1-.92,1.09l0.88,1.14v0h-0.8l-0.84-1.11H43.49v1.11H42.76V36.23h1.49ZM43.49,38H44.2c0.59,0,.8-0.2.8-0.54s-0.21-.56-0.8-0.56H43.49V38h0Z" fill="#fffffe"/>
              <path id="afLogoA" d="M23.24,49.41L26.39,40h1.55l3.14,9.39H23.24ZM30.7,35.24H23.56L16.51,55.08h7.67l1.52-2.4h2.85l1.58,2.4h7.68L30.7,35.24h0Z" fill="#fffffe"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  // Vuex
  import { mapActions, mapGetters } from 'vuex';

  // Components
  import FooterBrands from './FooterBrands.vue';
  
  export default {
    name: 'FooterBar',
    
    speak: {
      prefix: 'app.components.FooterBar'
    },

    components: {
      FooterBrands
    },

    computed: {
      ...mapGetters([
        'global'
      ])
    },

    methods: {
      ...mapActions([
        ''
      ]),

      afLogoAnim () {
        const afLogoA = document.getElementById('afLogoA');
        const afLogoR = document.getElementById('afLogoR');
        const afLogoFlame = document.getElementById('afLogoFlame');
        const afLogoSmoke = document.getElementById('afLogoSmoke');

        const tl = new TimelineMax();

        tl
          .set([afLogoA, afLogoFlame], { y: 0, opacity: 1, transformOrigin: 'center' })
          .set(afLogoSmoke, { y: 0, scale: 1, transformOrigin: 'center top' })

          .to(afLogoR, 0.25, { opacity: 0 })

          // Ignition
          .to(afLogoA, 0.5, { y: 4, ease: Power2.easeOut })
          .addLabel('ignition')
          .to(afLogoA, 0.10, { x: 1, rotation: 3 }, 'ignition')
          .to(afLogoA, 0.10, { x: -1, rotation: -3, ease: Power0.easeNone, repeat: 7, yoyo: true })
          .to(afLogoA, 0.10, { x: 0, rotation: 0 })

          .to(afLogoFlame, 0.05, { opacity: 0, yoyo: true, repeat: 12 }, 'ignition')
          .to(afLogoFlame, 0.05, { opacity: 1 })

          .to(afLogoSmoke, 1, { y: 2, scale: 1.3, ease: Power2.easeIn }, 'ignition')
          
          // Lift off
          .addLabel('liftoff')
          .to([afLogoA, afLogoFlame], 0.25, { y: -100 }, 'liftoff')
          .to(afLogoSmoke, 0.25, { y: 20 }, 'liftoff')

          // Reset animation
          .to(afLogoSmoke, 0.5, { y: 0, scale: 1, ease: Power2.easeOut }, '+=1')
          .to([afLogoA, afLogoFlame], 0.5, { y: 0, ease: Power2.easeOut })
          .to(afLogoR, 0.25, { opacity: 1 })
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/FooterBar.vue